export const afterScroll = (callback) => {
   window.onscroll = () => {
      callback()
   }   
}

export const debounce = (func, delay) => {
   let inDebounce
   return function() {
     const context = this
     const args = arguments
     clearTimeout(inDebounce)
     inDebounce = setTimeout(() => func.apply(context, args), delay)
   }
}

export const throttle = (func, limit) => {
   let inThrottle
   return function() {
     const args = arguments
     const context = this
     if (!inThrottle) {
       func.apply(context, args)
       inThrottle = true
       setTimeout(() => inThrottle = false, limit)
     }
   }
 }

export const getRandomNumber = (min, max) => {
   return Math.floor(Math.random()*(max-min+1)+min);
}

export const preloadimages = (arr) => {
   var newimages=[]
   var loadedimages=0
   var postaction=function(){}
   var arr=(typeof arr!="object")? [arr] : arr
   function imageloadpost(){
      loadedimages++
      if (loadedimages==arr.length){
         postaction(newimages) //call postaction and pass in newimages array as parameter
      }
   }
   for (var i=0; i<arr.length; i++){
      newimages[i]=new Image()
      newimages[i].src=arr[i]
      newimages[i].onload=function(){
         imageloadpost()
      }
      newimages[i].onerror=function(){
         imageloadpost()
      }
   }
   return { //return blank object with done() method
      done:function(f){
         postaction = f || postaction //remember user defined callback functions to be called when images load
      }
   }
}